import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
    static targets = [
        'cardNumber',
        'cardCode',
        'cardMonth',
        'cardYear',
        'stripeToken',
        'cardData',
        'submitButton',
    ]

    static values = {
        stripeKey: String,
    }

    // CreditCardsFormController
    // We load Credit Card form via turbo so initialize Stripe JS handling here

    connect() {
        this.#loadStripe()
    }

    async #loadStripe() {
        try {
            // Dynamically load Stripe library
            if (typeof window.Stripe === 'undefined') {
                await this.#loadStripeScript()
            }

            // Initialize Stripe with publishable key
            window.Stripe.setPublishableKey(this.stripeKeyValue)
            this.stripeLoaded = true
        } catch (error) {
            console.error('Failed to load Stripe library:', error)
            this.stripeLoaded = false
        }
    }

    #loadStripeScript() {
        return new Promise((resolve, reject) => {
            const script = document.createElement('script')
            script.src = 'https://js.stripe.com/v1/'
            script.onload = resolve
            script.onerror = reject
            document.head.appendChild(script)
        })
    }

    submit(evt) {
        // Intercept form submission because we interact with Stripe via AJAX.
        // When Stripe returns successfully it will submit the form at the end
        evt.preventDefault()

        // Check if Stripe is loaded
        if (!this.stripeLoaded) {
            console.error('Stripe library is not loaded yet')
            return
        }

        // Disable submit button and change text
        this.originalButtonText = this.submitButtonTarget.value
        this.submitButtonTarget.disabled = true
        this.submitButtonTarget.value = 'Processing...'

        // Submit stripe form if card_number is enabled
        if (!this.cardNumberTarget.disabled) {
            this.#processCard()
        }
    }

    #processCard() {
        const card = {
            number: this.cardNumberTarget.value,
            cvc: this.cardCodeTarget.value,
            expMonth: this.cardMonthTarget.value,
            expYear: this.cardYearTarget.value,
        }

        return window.Stripe.createToken(card, this.#handleStripeResponse.bind(this))
    }

    async #handleStripeResponse(status, response) {
        if (status === 200) {
            // Set the stripe token and card data in hidden fields
            if (this.hasStripeTokenTarget) this.stripeTokenTarget.value = response.id
            if (this.hasCardDataTarget) this.cardDataTarget.value = JSON.stringify(response.card)

            // Submit this form
            this.element.submit()
        } else {
            this.#showError(response.error.message)

            // Re-enable submit button and restore original text
            this.submitButtonTarget.disabled = false
            this.submitButtonTarget.value = this.originalButtonText
        }
    }

    #showError(message) {
        const alertHtml = `<div class="alert alert-danger alert-dismissible">
            <button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>
            ${message}
        </div>`

        const popupFlashNotices = document.getElementById('popUpFlashNotices')
        popupFlashNotices.insertAdjacentHTML('afterbegin', alertHtml)
    }
}
